import {
  SET_STATES
} from './mutationTypes'

export const mutations = {
  [SET_STATES]: (state, payload) => state.states = payload
}
